/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type GetPatientsBasicsType = (typeof GetPatientsBasicsType)[keyof typeof GetPatientsBasicsType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPatientsBasicsType = {
  ALL: 'ALL',
  INDEX: 'INDEX',
  INDEX_AND_SCREENING_INDIVIDUAL: 'INDEX_AND_SCREENING_INDIVIDUAL',
  CONTACT_TRACING: 'CONTACT_TRACING'
} as const;
